import React from 'react';
import filterIcon from '../../../../assets/image/filter-black-icon.svg';
import Button from '../../../../component/ui/Button';
import FilterRender from './filterRender';
import DatePicker from 'react-datepicker';

export default function ReportSubHeaderComponent({
	getReportList,
	params,
	setParams,
	startDate,
	endDate,
	setCustomDateRange,
	dropdownState,
	setDropdownState,
	filters,
}) {
	return (
		<div className="container-fluid px-2 py-3">
			<div className="row g-2 align-items-center">
				<img
					className="cursor-pointer d-none d-lg-block"
					style={{ width: '16px', height: '16px' }}
					src={filterIcon}
					alt="filter-icon"
				/>

				<div className="col-12 col-lg">
					<div className="d-flex flex-wrap gap-3 align-items-center">
						<div
							className="fw-semibold fs-5"
							style={{ color: '#0F1C35' }}
						>
							Filters:
						</div>

						{filters.map((filter) => (
							<div key={filter.key}>
								<FilterRender
									filter={filter}
									params={params}
									setParams={setParams}
									state={dropdownState}
									setState={setDropdownState}
								/>
							</div>
						))}

						{dropdownState.isCustomDateOpen && (
							<div>
								<DatePicker
									selectsRange
									startDate={startDate}
									endDate={endDate}
									onChange={(update) => setCustomDateRange(update)}
									isClearable={true}
									maxDate={new Date()}
									className="form-control"
								/>
							</div>
						)}

						<Button
							type="button"
							className="btn-gray mt-0 px-4 w-100"
							button="Run Report"
							onClick={() => getReportList()}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
